<template>
  <div class="modal modal__opened">
    <div class="modal__bg" />
    <div
      :class="['modal__scrollbox', { modal__scrollbox_closable: closable }]"
      @click.self="backdropClick"
    >
      <div class="modal__inner">
        <div v-if="closable" class="modal__close" @click="close" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closable: {
      type: Boolean,
      default: true
    },
    special: String
  },
  methods: {
    close() {
      if (this.special == "special") {
        this.$metrika.showPixel(
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizo&pr=%random%&ptrc=b"
        );
      }
      this.$emit("close");
    },
    backdropClick() {
      if (this.closable) {
        this.close();
      }
    }
  }
};
</script>
